import React, { useState, useEffect, useRef} from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
//import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective } from '@syncfusion/ej2-react-gantt';
import "../assets/css/styles.table.css"
 
import '../App.css';
import AxiosFetchData from './AxiosFetchData.js'
import { setValue } from '@syncfusion/ej2-base';
 
import { DialogFormTemplate } from './template';
import { ColumnDirective, ColumnsDirective, TreeGridComponent,RowDD,Inject , Aggregate, AggregatesDirective } from '@syncfusion/ej2-react-treegrid';
import { Edit, Toolbar, AggregateColumnDirective, AggregateColumnsDirective, AggregateDirective  } from '@syncfusion/ej2-react-treegrid';
import { getValue } from '@syncfusion/ej2-base';
 
import VirtualizedSelect from 'react-virtualized-select';
 
import { getObject } from '@syncfusion/ej2-grids';
import Layout from './Layout.js';
import Helper from './Helper.js';
import PrintPreview from './PrintReview.js';
import Radio, { RadioProps } from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Input from '@mui/material/Input';
import { IMaskInput } from 'react-imask';




const AddInvoice =   () => {
    const { id } = useParams();
    const [rows, setRows] = useState([]);
    const [confirmTaskOpen,setConfirmTaskOpen] = useState(false);
    const Navigate = useNavigate();
    const [dataTask, setDataTask] = useState({});
    const [taskName, setTaskName] = useState({});
    const [taskDate, setTaskDate] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [delegasiList, setDelegasiList] = useState([]);
    const [prioritasList, setPrioritasList] = useState([]);
    const [selectedPrioritas, setSelectedPrioritas] = useState('');
    const [action, setAction] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [typeList, setTypeList] = useState([]);
    const [selectedDelegasi, setSelectedDelegasi] = useState('');
    const [kemajuan, setKemajuan] = useState(0);
    const [idTask, setIdTask] = useState('');
    const [confirmDeleteOpen,setConfirmDeleteOpen] = useState(false);
    const [layout, setLayout] = useState('Task');
    const [timelineSetting, setTimelineSetting] = useState({});
    const inputRef =  useRef(null);
    const [partNo, setPartNo] = useState('');
    const [qty ,setQty] = useState(0);
    const [description ,setDescription] = useState('');
    const [price ,setPrice] = useState(0);
    const [tipeAction ,setTipeAction] = useState(0);
    const [total ,setTotal] = useState(0);
    const [grandTotal ,setGrandTotal] = useState(0);
    const [persentase ,setPersentase] = useState(0);
    const [persentaseNominal ,setPersentaseNominal] = useState(0);
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('ReturnUrl');
    const [message ,setmessage] = useState('');
    const [retensi ,setRetensi] = useState(0);
    const [retensiVal ,setRetensiVal] = useState(0);
    const [totalAfterRetention ,setTotalAfterRetention] = useState(0);
    const [totalOrigin ,setTotalOrigin] = useState(0);
    const [InvoiceType ,setInvoiceType] = useState('Percent');
    const [totalDisc ,setTotalDisc] = useState(0);
    const [open, setOpen] =  useState(false);
    const [treedata ,setTreedata] = useState('');
    const [tax ,setTax] = useState(0);
    const [invNo ,setInvNo] = useState('');
    const [customer ,setCustomer] = useState('');
    const [customer2 ,setCustomer2] = useState('');
    const [isCustomer ,setIsCustomer] = useState(true);
    const [roleAccess, setRoleAccess] = useState([]);
    const [invNoCustom, setInvNoCustom] =  useState('');
    const [selectedValue, setSelectedValue] = React.useState('custom');
    const [type, setType] =  useState({});
    var treegrid;
    
    useEffect(() => {
         (async () => {
           await GetTaskList();
           await GenerateInvNo();
       
       })();
       
     }, []);  

    const GetTaskList = async () => {
        try{
          const response = await AxiosFetchData.get(`GetQuotationById/${id}/invoice`).refreshToken(Navigate,"invoice")
          if(response){   
             const rowsWithRowNumbers = response.data.map((row, index) => ({
                 ...row,
                rowNumber: index + 1,
             }));

             // var ListIn = response.data.filter(row => row.type == "ex")[0].totalpo
             // alert((response.data.filter(row => row.type == "ex")[0] ?  response.data.filter(row => row.type == "ex")[0].totalpo : 0) + (response.data.filter(row => row.type == "in")[0] ?  response.data.filter(row => row.type == "in")[0].totalpo : 0))
              setRows(rowsWithRowNumbers);
              setRoleAccess(response.roleaccess)
              setTotalOrigin((response.data.filter(row => row.type == "ex")[0] ?  response.data.filter(row => row.type == "ex")[0].totalpo : 0) + (response.data.filter(row => row.type == "in")[0] ?  response.data.filter(row => row.type == "in")[0].totalpo : 0))
              //alert(response.data[0].tax)
              setTax(response.data[0].tax)
              // console.log(response.data)
              // var totalDisc=0;
              // response.data.forEach((element) => {
              
              // totalDisc += element.disc ?? 0;
              // });
              //alert(totalDisc)
              var totaldisc = (response.data.filter(row => row.type == "ex")[0] ?  response.data.filter(row => row.type == "ex")[0].disc : 0) + (response.data.filter(row => row.type == "in")[0] ?  response.data.filter(row => row.type == "in")[0].disc : 0);
              setTotalDisc(totaldisc);

             // await handleTotal(5)

          }
        }catch(e){
          setmessage(e.message);
        }
        
       
    }
 
    const GenerateInvNo = async () => {
      try{
        const response = await AxiosFetchData.get(`GenerateCode/${id}`).refreshToken(Navigate)
       
        setInvNo(response.data);
        setCustomer(response.data.split('/')[2])
        if(response.data.split('/')[2] == ''){
          setIsCustomer(false)
         
        }else{
          setSelectedValue('system')
        }
      }catch(e){
          setmessage(e.message);
      }
    }
   
    const AddParentTask = async () => {
       try{
        //alert(invNo)
        if(customer == '' && selectedValue == "system"){
          setmessage("Please complete the invoice no")
          setType("error")
          return;
        }

        if(selectedValue == "custom"){
          if(invNoCustom == ''){
            setmessage("Please complete the invoice no")
            setType("error")
            return;
          }

         
          if(invNoCustom.split('-').length != 2){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom[7]  != "-"){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom.split('-')[0].length != 7){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          
          if(isNaN(invNoCustom.substring(2,7))){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom.split('/').length != 5){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom.split('-')[1].substring(0,1).length != 1){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(isNaN(invNoCustom.split('-')[1].substring(0,1))){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }
          

          if(invNoCustom.split('/')[1] != "MS"){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom.split('/')[2] == ""){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom.split('/')[3].length != 2){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom.split('/')[4].length != 4){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(isNaN(invNoCustom.split('/')[3])){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(isNaN(invNoCustom.split('/')[4])){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom.split('/')[0].length != 9){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }

          if(invNoCustom.split('-')[0].substring(2,4) != invNoCustom.split('/')[4].substring(2,4)){
            setmessage("Invoice number is not valid")
            setType("error")
            return;
          }
        }
      
        if(!isCustomer){
          var invno = selectedValue == "system" ? invNo.split('/')[0] + "/MS/" + customer + "/" + invNo.split('/')[3] + "/" + invNo.split('/')[4] : invNoCustom.trim()
          var inv = await AxiosFetchData.get(`CheckInvoiceNo/${encodeURIComponent(invno)}`).refreshToken(Navigate,"invoice");
       
          if(inv.data){
            setmessage(invno.split('-')[0] + " already exist")
            setType("error")
            if(selectedValue == "system"){
              await GenerateInvNo();
            }
           
            return;
          }
        }
        

        if(persentase == 0){
          setmessage("Inv(%) cannot be zero")
          setType("error")
          return;
        }

        if(total != (grandTotal)){
          setmessage(`Total should be the same as Invoice (${InvoiceType == "Percent" ? `${persentase}%` : `Rp.${Helper.formatAsCurrency(persentase)}`})`)
          setType("error")
          return;
        }
 
        var data = {
          data : JSON.stringify(treegrid.getCurrentViewRecords()),
          project_id : id,
         // kode : null,
          kode : selectedValue == "system" ? invNo.split('/')[0] + "/MS/" + customer + "/" + invNo.split('/')[3] + "/" + invNo.split('/')[4] : invNoCustom,
          tanggal : Helper.GetDateYYYYMMDD(new Date()),
          total_all : totalOrigin,
          //persentase: total,
          persentase: InvoiceType == "Percent" ? persentase : persentaseNominal,
          //total : grandTotal * (total /100),
        //  total : total,
          total : totalAfterRetention,
          status : "Unpaid",
          deskripsi  : description,
          retensiVal : retensiVal,
          type : InvoiceType,
          rev : 0,
          rev_default: 1
        }

        if(treegrid.getCurrentViewRecords().length > 0){  
          var response =  await AxiosFetchData.post("CheckInvoice",data).refreshToken(Navigate)
           
          if(!response.data){
              setmessage("Invoice is already 100%, can't add more invoices")
              return;
          }
          
          response = await AxiosFetchData.post("AddInvoice",data).refreshToken(Navigate);
          if(response){
             setmessage(response.data)
             Navigate(`/${myParam}`)
              return;
          }
        }
   
        setmessage("No Data Available");
        return;
       }catch(e){
          setmessage(e.message);
       }
        
    };

    const toolbarOptions = ['Add', 'Edit', 'Delete',   { text: 'Clear', tooltipText: 'Clear', id: 'toolbarfilter', align: 'Right' },{ text: 'Default', tooltipText: 'Default', id: 'toolbarfilter2', align: 'Right' },{ text: 'Preview', tooltipText: 'Preview', id: 'toolbarfilter3', align: 'Right' }];
    const dialogTemplate = (props) => {
        const obj = [props, treegrid];
        return (<DialogFormTemplate {...obj}/>);
    };
    const editOptions = {
        allowAdding: true,
        allowDeleting: true,
        allowEditing: true,
        mode: 'Dialog',
        newRowPosition: 'Child',
        template: dialogTemplate
    };

    const actionComplete = (args) => {
        if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
            // Add Validation Rules
            const form = args.form;
           // form.ej2_instances[0].addRules('qty', { max: 100 });
            if (args.requestType === 'beginEdit') {
             // console.log(args.form.elements.namedItem("part_no"))
             // form.elements.namedItem('part_no').focus();
            }
        }
 
    };

    const actionBegin = (args) => {
     
        if (args.requestType === 'save') {
             
        }

        if ((args.requestType === 'add')) {
          // const val = args.form.querySelector("#invoice_id").value;
            setValue('data.po_detail_id',Math.random().toString().split('.')[1], args);
            setValue('data.type',"new", args);
        }

        if ((args.requestType === 'delete')) {
          // if(args.data[0].type != "new" && args.data[0].type != "title" && args.data[0].type != "null"){
          //   args.cancel = true;
          //   setmessage("cannot be deleted");
          // }
              
          //alert(getValue('data.part_no', args.rowData))
        }
    };

    function  rowDrop(args) {
      if (args.dropPosition == 'middleSegment' || Object.keys( args.dropPosition).length == 0) {
        args.cancel = true;
        treegrid.reorderRows([args.fromIndex], args.dropIndex, 'above');
     }
    }
    const selectionSettings = { type: 'Multiple' };

    const TotalTemplate = (props) => {
      if (getObject('price', props) != null && getObject('newqty', props) != null) {
           return Helper.formatAsCurrency((getObject('price', props) * getObject('newqty', props)));
        }
        return null;
     
   };

   const priceTemplate = (field, data, column) => {
    if (getValue('price', data) != null) {
      return  Helper.formatAsCurrency(getValue('price', data));
    }
    return null;
  };

   const customAggregateFn = (row) => {
       const sampleData = getObject('result', row);
       //console.log(sampleData)
       let data = 0;
       if(sampleData){
        sampleData.filter((item) => {
          if(getObject('price', item) && getObject('newqty', item)){
              data += getObject('price', item) * getObject('newqty', item);
          }
      });
      }
      
      setGrandTotal(data)
      return data;
   };
   const custom1 = (props) => {
    return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Total :</td><td>{(Helper.formatAsCurrency(getObject('Custom', props)))}</td></tr></table>)
     //  return (<span>Total :  {(Helper.formatAsCurrency(getObject('Custom', props)))}</span>);
   };

   const custom =   (props) => {
    return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>inv{InvoiceType=="Percent" ? "(" + persentase + '%)' : ''} :</td><td>{Helper.formatAsCurrency(total)}</td></tr></table>)
    //return (<span>inv({persentase}%) :  {Helper.formatAsCurrency(total)}</span>);
      
   };

   const custom2 =  (props) => {
    setRetensiVal(totalOrigin * (retensi / 100));
    //console.log(retensi);
    return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Retention({retensi}%) :</td><td>{Helper.formatAsCurrency(totalOrigin * (retensi / 100))}</td></tr></table>)
     
   };

   
   const custom3 =    (props) => {
    setTotalAfterRetention(total - (totalOrigin * (retensi / 100)));
    return (<table border="0" width={"100%"}><tr><td  style={{width:100, textAlign:'right'}}>Grand Total:</td><td >{Helper.formatAsCurrency(total - (totalOrigin * (retensi / 100)))}</td></tr></table>)
   };

   const custom4 = (props) => {
      return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Total Project :</td><td>{Helper.formatAsCurrency(totalOrigin)}</td></tr></table>)
   };

   const custom5 =   (props) => {
    return (<table border="0" width={"100%"}><tr><td colSpan={2}>&nbsp;</td></tr></table>)
   };

async function handleTotal(data){
  if(!data){
   data = 0;
  }

  var index = 0;
  if(data.toString().length > (((data * 1).toString())).length){
    index = data.toString().length - (((data * 1).toString())).length
  }

  data = data.toString().substring(index)
  
  //if(!data){
 //  data = 0;
 //}

 if(parseFloat(data) > 100 && InvoiceType == 'Percent'){
  setmessage("must be smaller than 100%")
  return;
 }
 
 setPersentase(data)
  
 
  const response = await AxiosFetchData.get(`GetInv/${id}/${data}/${totalOrigin}/${InvoiceType}/0`).refreshToken(Navigate);
  if(response){
    // setPersentase(data)
    setTotal(response.data.value);
     
     if(InvoiceType == "Nominal"){
    
        setPersentaseNominal(response.data.persentase);
        if(response.data.persentase > 100 && InvoiceType == 'Nominal'){
          setmessage("must be smaller than 100%")
          setPersentase(0)
          setTotal(0)
          return;
      }
     }
    
    
    await GetRetention(data, response.data.persentase)
  }
 
}

const GetRetention = async (persentase, persentaseNominal=null) => {
  try{
   // var response =  await AxiosFetchData.get(`GetInvoice/${id}`).refreshToken(Navigate);
   // if(response){
   var ret = 0;
      var response = await AxiosFetchData.get(`GetRetention/${id}`).refreshToken(Navigate);
      // console.log(response);
      if(response.data){
        if(persentase == 100 || (persentaseNominal && (persentaseNominal == 100))){
         
          setRetensi(response.data.retensi)
        }else{
       
          setRetensi(0)
        }
        
      }else{
        setRetensi(0)
      }
//console.log(ret)
   //    setRetensi(parseInt(ret))
  //  }
     
  }catch(err){
    setmessage(err.message)
  }
  
  
}

const toolbarClick = (args) => {
  //alert(treegrid)
   
  if ( args.item.text ==='Clear') {
    
      setRows([])
  }

  if ( args.item.text ==='Default') {
     
     GetTaskList();
   }

   if (args.item.text ==='Preview') {
     
     document.getElementById('btnPreview').click();
    
 }
  
};

function handlePreview(){
 // alert(treegrid.getCurrentViewRecords())
 var data = {
    treeview : treegrid.getCurrentViewRecords(),
    invoice : {
      persentase : persentase,
      total_all :  totalOrigin,
      total : total,
      //kode: invNo,
      kode: selectedValue == "system" ? invNo.split('/')[0] + "/MS/" + customer + "/" + invNo.split('/')[3] + "/" + invNo.split('/')[4] : invNoCustom,
      tax : tax
    },
    retensi : retensi
  }

//setTreedata(JSON.stringify(treegrid.getCurrentViewRecords()))
setTreedata(JSON.stringify(data))
setOpen(true);
}

const settings = { wrapMode: 'Content' };

function SystemInvNo(){
  return (
    <div style={{display: 'flex'}}>
       
    <span style={{fontSize:11, marginTop:10}}>{invNo.split('/')[0]}/MS/&nbsp;</span>
    <input
       type="text"
       value={customer}
       name="inNo"

       onChange={(e) => setCustomer(e.target.value)}
     
       className='form-control'
       style={{width:100, height:17, marginTop:10}}
       required
       disabled={isCustomer}
      // style={{margin:5}}
   />&nbsp;
   <span style={{fontSize:11, marginTop:10}}>/ {invNo.split('/')[3]} /{invNo.split('/')[4]} </span>
</div>
  )
 
}

function  CustomInvNo(){
  
  
  return(
   
   <Input
      value={invNoCustom}
      fullWidth 
      onChange={(e) => {
        setInvNoCustom(e.target.value)
      }}
      style={{width:"100%", height:20, marginTop:8}}
   />
   
  )
 
}

const handleChange = (event) => {
  setSelectedValue(event.target.value);
  if(event.target.value === "custom"){
    setCustomer('')
  }else{
    setInvNoCustom('')
  }
   
};

return (
      <Layout message={message} setmessage={setmessage} tipe={type} settipe={setType}>
   
  <div className='pd'><b>ADD INVOICE</b> </div>
 
  <div className="pd"  >
           <div style={{display:"flex", width:"100%"}}>
              <div style={{marginTop:5,marginBottom:10, width:"50%"}}>
                <button onClick={() => AddParentTask()} className='btn btn-primary' disabled={!roleAccess.CREATE} style={{width:150}}>SAVE</button> 
              </div>
              <button onClick={() => handlePreview()} className='btn btn-primary' id="btnPreview" style={{display:'none'}}>SAVE</button> 
            </div>
          
            <div className="container-form">
              <div className="column-form col-lg-12" > 
                  <label>INV</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                  <div style={{display: 'flex'}}>
                    <div className='col-lg-6' >
                      <input
                        type="number"
                        value={persentase == '' ? 0 : persentase}
                        name="address"
                        min ={0}
                        max = {100}
                        onChange={(e) => handleTotal(e.target.value)}
                        className='form-control'
                        required
                        style={{width: '100%'}}
                     />
                    </div>
                    <div className='col-lg-6'>
                        <VirtualizedSelect 
                                       options={[{label : 'Percent (%)', value: 'Percent'},{label : 'Nominal (Rp)', value: 'Nominal'}]}
                                       //onChange={(option) => setSelectedOptionPayment(option)}
                                       onChange={   (option) => {setInvoiceType(option.value); setPersentase(0); setTotal(0)}}
                                       value={InvoiceType}
                                       clearable={false}
                                       searchable={true}
                                       required
                                       
                                       width={"100%"}
                                       fullWidth
                                    />
                  </div>
                 
                  </div>
                  
                </div>

                <div className="column-form"> 
                <label>INV NO</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                    
                    <div style={{fontSize:9,marginTop:0,marginLeft:0}}><i><b><u>By manual:</u></b></i></div>
                    <div style={{display:'flex'}}>
                        <Radio
                          checked={selectedValue === 'custom'}
                          onChange={handleChange}
                          value="custom"
                          name="radio-buttons"
                          inputProps={{ 'aria-label': 'A' }}
                          disabled={isCustomer}
                        />
                         <Input
                            value={invNoCustom}
                            fullWidth 
                            onChange={(e) => {
                                  setInvNoCustom(e.target.value)
                            }}
                            disabled={selectedValue === 'system' ? true : false}
                            style={{width:"100%", height:20, marginTop:8}}
                            placeholder='NR00000-0/MS/{CUSTOMER}/MM/YYYY'
                          />
                    </div>
                    <div style={{fontSize:9,marginTop:20,marginLeft:0}}><i><b><u>By system:</u></b></i></div>
                    <div style={{display:'flex'}}>
                        <Radio
                          checked={selectedValue === 'system'}
                          onChange={handleChange}
                          value="system"
                          name="radio-buttons"
                          inputProps={{ 'aria-label': 'A' }}
                        />
                        <div style={{display: 'flex'}}>
                          <span style={{fontSize:11, marginTop:10}}>{invNo.split('/')[0]}/MS/&nbsp;</span>
                          <input
                            type="text"
                            value={customer}
                            name="inNo"
                            onChange={(e) => setCustomer(e.target.value)}
                            className='form-control'
                            style={{width:100, height:17, marginTop:10, fontSize:8}}
                            required
                            disabled={selectedValue === 'custom' ? true : isCustomer}
                           // disabled={isCustomer}
          
                            />&nbsp;
                            <span style={{fontSize:11, marginTop:10}}>/ {invNo.split('/')[3]} /{invNo.split('/')[4]} </span>
                        </div>
                    </div>
                {/* <div>
                <input
                        type="text"
                        value={customer}
                        name="inNo"
            
                        onChange={(e) => setCustomer(e.target.value)}
                      
                        className='form-control'
                        style={{width:100, height:25}}
                        required
                        disabled={isCustomer}
                       // style={{margin:5}}
                    />
                </div> */}
                </div>

                <div className="column-form"> 
                <label >Description</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                  <input
                    type="text"
                    value={description}
                    name="address"
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter the purchase No."
                    className='form-control'
                    fullWidth
                    required
                    style={{margin:5}}
                  />
                </div>
          </div>
           
            {layout=="Task" && (
            <div>
              <TreeGridComponent dataSource={rows} treeColumnIndex={1} childMapping='subChild' height='100%'   enableCollapseAll={false}   editSettings={editOptions} toolbar={toolbarOptions} ref={g => treegrid = g} actionBegin={actionBegin} actionComplete={actionComplete} allowRowDragAndDrop={true} selectionSettings={selectionSettings} rowDrop={rowDrop.bind(this)} toolbarClick={toolbarClick} allowTextWrap={true} textWrapSettings={settings}>
                 <ColumnsDirective>
                    {/* <ColumnDirective field='rowNumber' headerText='No' width='70' textAlign='Left'  /> */}
                    <ColumnDirective field='po_detail_id' headerText='ID' width='50' textAlign='Right' isPrimaryKey={true}  visible={false}/>
                    <ColumnDirective field='part_no' headerText='Part No.' width='300'/>
                    <ColumnDirective field='descriptions' headerText='Description' width='350'  textAlign='Left' />
                    <ColumnDirective field='newqty' headerText='Qty' width='100'  textAlign='Right' />
                    <ColumnDirective field='unit_name' headerText='Unit' width='100'  textAlign='Right' />
                    <ColumnDirective field='price' headerText='Price' width='120'  textAlign='Right' valueAccessor={priceTemplate}/>
                    <ColumnDirective field='total' headerText='Total' width='300' template={TotalTemplate} textAlign='Center'/>
                    <ColumnDirective field='code' headerText='Code' width='350'  textAlign='Left' visible={false}/>
                    <ColumnDirective field='rev' headerText='Rev' width='350'  textAlign='Left' visible={false}/>
                    <ColumnDirective field='type' headerText='type' width='50'  textAlign='Left' visible={false}/>
{/*                     
                    <ColumnDirective field='Action 1' headerText='Add Parent' width='120' textAlign='Right'/>
                    <ColumnDirective field='Action 2' headerText='Add Sub' width='100' textAlign='Right'/>
                    <ColumnDirective field='Edit' headerText='Edit Task' width='80' textAlign='Right'/>
                    <ColumnDirective field='Delete' headerText='Delete Task' width='100' textAlign='Right'/> */}
                </ColumnsDirective>
                <AggregatesDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom1}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                 {/* <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom4}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective> */}
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom5}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>  
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom2}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom3}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                </AggregatesDirective>
                <Inject services={[Edit, Toolbar, RowDD, Aggregate]}/>
            </TreeGridComponent>;
            </div>
            )}
            
    </div>
      <PrintPreview id={id} open={open} setopen={setOpen}>
                  {treedata}
      </PrintPreview>
 </Layout>

       
    );
}
 

export default AddInvoice;